import { useState } from "react";
import { Instagram, MessageCircle, ArrowRight, Zap, ShoppingBag, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
const Leads = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    business: "",
    problem: ""
  });
  const {
    toast
  } = useToast();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const {
        error
      } = await supabase.from("consulting_leads").insert({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        business: formData.business,
        problem: formData.problem
      });
      if (error) throw error;
      setIsSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        business: "",
        problem: ""
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast({
        title: "Σφάλμα",
        description: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
  };
  return <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-md mx-auto px-5 py-12">
        {/* Hero Section */}
        <div className="flex flex-col items-center text-center mb-12">
          {/* Profile Photo */}
          <div className="relative mb-6">
            <div className="w-28 h-28 rounded-full overflow-hidden ring-2 ring-primary/50 ring-offset-4 ring-offset-background">
              <img src="/lovable-uploads/mike-profile.jpg" alt="Mike Foto" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <Zap className="w-4 h-4 text-primary-foreground" />
            </div>
          </div>

          {/* Name */}
          <h1 className="text-2xl font-bold tracking-tight mb-1">Mike Foto</h1>
          <p className="text-xs text-muted-foreground mb-4">Co-Founder @ RentMySite, UppLead & TapG</p>

          {/* Social Links */}
          <div className="flex gap-3 mb-8">
            <a href="https://www.instagram.com/mikefotto/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 rounded-full bg-secondary hover:bg-secondary/80 transition-colors">
              <Instagram className="w-5 h-5" />
              <span className="text-sm font-medium">Instagram</span>
            </a>
            <a href="viber://chat?number=%2B306986904312" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#7360F2] hover:bg-[#5a4ad4] transition-colors">
              <MessageCircle className="w-5 h-5 text-white" />
              <span className="text-sm font-medium text-white">Viber</span>
            </a>
          </div>

          {/* Main Headline */}
          <h2 className="text-lg font-medium leading-relaxed text-muted-foreground">
            ​  ​ <span className="text-foreground">​Δες πως μπορούμε να συνεργαστούμε ⤵ </span>
          </h2>
        </div>

        {/* CTA Cards */}
        <div className="space-y-4">
          {/* Primary CTA - 1-1 Consulting */}
          <div className="relative group">
            <div className="absolute inset-0 bg-primary/20 rounded-2xl blur-xl group-hover:bg-primary/30 transition-all duration-300" />
            













          </div>

          {/* Secondary CTA - rentmysite */}
          <div className="bg-card border border-border rounded-xl p-5 hover:border-muted-foreground/50 transition-colors">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                <Zap className="w-5 h-5 text-foreground" />
              </div>
              <div className="flex-1">
                <h3 className="text-base font-bold mb-1">Δωρεάν Website έτοιμο σε 24 ώρες! </h3>
                <p className="text-sm text-muted-foreground mb-1">
                    + Διαφημίσεις  
                </p>
                <p className="text-xs text-muted-foreground mb-3">Από μόλις 29€/μήνα - Χωρίς προκαταβολές</p>
                <a href="https://rentmysite.gr" target="_blank" rel="noopener noreferrer">
                  <Button variant="secondary" className="w-full font-medium group/btn">
                    Πάτα εδώ
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                    rentmysite.gr
                  </Button>
                </a>
              </div>
            </div>
          </div>

          {/* Third CTA - upplead eShop */}
          


















        

          {/* Fourth CTA - TapG Google Reviews */}
          


















        
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Mike Foto
          </p>
        </div>
      </div>

      {/* Contact Modal */}
      <Dialog open={isModalOpen} onOpenChange={closeModal}>
        <DialogContent className="bg-card border-border max-w-sm mx-auto">
          <DialogHeader>
            <DialogTitle className="text-lg font-bold">Πάτα εδώ </DialogTitle>
          </DialogHeader>

          {isSubmitted ? <div className="py-8 text-center">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
                <Zap className="w-8 h-8 text-primary" />
              </div>
              <p className="text-foreground font-medium">Ευχαριστώ!</p>
              <p className="text-sm text-muted-foreground mt-1">
                Θα επικοινωνήσω σύντομα.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Input placeholder="Όνομα" value={formData.name} onChange={(e) => setFormData({
              ...formData,
              name: e.target.value
            })} required className="bg-secondary border-border" />
              </div>
              <div>
                <Input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({
              ...formData,
              email: e.target.value
            })} required className="bg-secondary border-border" />
              </div>
              <div>
                <Input type="tel" placeholder="Τηλέφωνο" value={formData.phone} onChange={(e) => setFormData({
              ...formData,
              phone: e.target.value
            })} required className="bg-secondary border-border" />
              </div>
              <div>
                <Input placeholder="Επιχείρηση (τι επιχείρηση έχεις)" value={formData.business} onChange={(e) => setFormData({
              ...formData,
              business: e.target.value
            })} required className="bg-secondary border-border" />
              </div>
              <div>
                <Textarea placeholder="Τι σε καίει περισσότερο αυτή τη στιγμή;" value={formData.problem} onChange={(e) => setFormData({
              ...formData,
              problem: e.target.value
            })} required rows={3} className="bg-secondary border-border resize-none" />
              </div>
              <Button type="submit" className="w-full bg-primary hover:bg-primary/90 font-semibold" disabled={isSubmitting}>
                {isSubmitting ? "Αποστολή..." : "Στείλε"}
              </Button>
            </form>}
        </DialogContent>
      </Dialog>
    </div>;
};
export default Leads;